import { POST } from '@/api'
import { addId, initStatus, updateShowStatus, toShortLabel } from '@/utils/analysis'

export default {
  namespaced: true,
  state: {
    charts: null,
    table: null,
    busy: false,
  },
  modules: {},
  mutations: {
    set(state, data) {
      state.charts = data.charts?.qty ?? null
      state.table = {
        ...data.table,
        value: initStatus(addId(data.table?.value)),
      }
    },
    toggle(state, id) {
      state.table.value = updateShowStatus(state.table.value, id)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    chart({ charts }, { statuses }) {
      return unit => {
        if (!charts) return null
        // 表示されるカラムのみ抽出
        const filteredChart = charts.map(([term, ...rest]) => [
          term,
          ...rest.reduce((accumulator, value, index) => (statuses[index] ? [...accumulator, value] : accumulator), []),
        ])
        // ラベルを表示用に変換する
        const [columns, ...rows] = filteredChart.map(([term, ...rest], idx) => [
          idx === 0 ? term : toShortLabel(term, unit),
          ...rest,
        ])
        return [columns, ...rows]
      }
    },
    hAxis({ charts }) {
      return charts.map(([term]) => term).filter(Boolean) ?? []
    },
    header({ table }) {
      return table?.header ?? null
    },
    data({ table }) {
      return table?.value ?? []
    },
    colors(state, { statuses }, rootState, { 'analysis/colors/customer': colors }) {
      return statuses.reduce(
        (accumulator, status, index) => (status ? [...accumulator, colors[index]] : accumulator),
        [],
      )
    },
    statuses({ table }) {
      return table?.value?.map(({ isShow }) => isShow) ?? []
    },
  },
  actions: {
    async get({ commit, state }, { unit, startTerm, endTerm, timeZone, statusType, dashboardFlg }) {
      if (state.busy) return
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/analysis/reservation/customer', {
        unit,
        startTerm,
        endTerm,
        timeZone,
        statusType,
        dashboardFlg: dashboardFlg || 0,
      })

      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
  },
}
